import { type AxiosRequestConfig } from 'axios'

const updateEvent = (id: string, data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: '/events/item',
    data,
    params: {
      id
    }
  }
}

export { updateEvent }
